<template>
    <div v-if="$props.isShow" class="dragHandle">
        <div v-if="mountedSuccessfully" class="text-truncate" @contextmenu="show">
            <!--            <v-avatar class="mb-2" v-if="mountedSuccessfully">
                            &lt;!&ndash;                v-if="!showInitials"&ndash;&gt;
                            &lt;!&ndash;                :src="'img/applicationsIcons/'+packageName+ '.png'"&ndash;&gt;
                            &lt;!&ndash;                <v-img :src="require('@/assets/phone_types/Nexus5/icons/com.android.vending.png')" />&ndash;&gt;

                            <v-img
                                :src="getIconPath(packageName)" :title="appName" @error="setShowInitials(true)"
                            />

                            &lt;!&ndash;                <span v-if="showInitials">{{ appName.charAt(0).toUpperCase() }}</span>&ndash;&gt;
                        </v-avatar>-->

            <v-avatar :class="{'app-icon-outline': showInitials}" :size="$vuetify.breakpoint.smAndDown ? 32 : 48"
                      class="mb-2"
                      @dblclick="emitDoubleClick(packageName)">

                <v-img v-if="!showIconFromCommon && !showInitials"
                       :src="getIconPath()" :title="appName" @error="setShowIconFromCommon"
                />
                <v-img
                    v-else-if="!showInitials && showIconFromCommon"
                    :src="getIconPathFromCommon()" :title="appName" @error="setShowInitials"
                />
                <span v-else>
<!--                    class="primary&#45;&#45;text"-->
                    <span v-text="getInitials(appName)"></span>
                </span>

            </v-avatar>

            <div class="text-truncate ma-auto caption max-width-80">
                <v-icon v-if="$props.appParams?.time_condition?.length > 0"
                        :title="$gettext('This app has time condition(s)')" class="cursor-default mr-1 mb-auto"
                        x-small
                        v-text="icons.mdiClockOutline"></v-icon>
                <span :title="appName" class="cursor-default" v-text="appName"></span>
            </div>
        </div>

        <v-menu
            v-if="x > 0 && y > 0 && showMenu.packageName === packageName"
            v-model="showMenu['value']"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
        >
            <v-list dense>
                <v-list-item>
                    <v-list-item-content>
                        <h4 class="text-truncate" v-text="appName"></h4>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                    v-for="(item, index) in rightClickContextMenuForApp"
                    :key="index"
                    @click="processRightClickMenuForApp(item, index, $event)"
                >
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item>
                <!-- nested menu for existing time conditions-->

                <!--                open-on-hover-->
                <v-menu v-if="$props.appParams?.time_condition?.length > 0" dense offset-x>
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on">
                            <v-list-item-content>
                                <v-list-item-title>{{ $gettext('Current time conditions') }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-icon color="primary" small v-text="icons.mdiChevronRight"></v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-content>
                                <h5 class="text-center">{{ $gettext('Time Conditions') }}</h5>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mb-1"></v-divider>
                        <div
                            v-if="$props.appParams?.time_condition?.length > 0">
                            <v-list-item
                                v-for="(tc, tcIndex) in $props.appParams.time_condition">
                                <v-list-item-content>
                                    <v-list-item-title>{{ tcIndex + 1 }}. {{ tc.from }} - {{ tc.to }}
                                        <span v-for="(w, weekIndex) in weekdays">
                                        <span v-if="tc.days.includes(weekIndex+1)"
                                              v-text="weekdays[weekIndex].charAt(0).toUpperCase()"></span>
                                    </span>
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-row>
                                        <v-col class="px-2 py-0">
                                            <v-icon :color="!isDark ? 'primary' : ''"
                                                    small @click="openAddEditAppTimeCondition('edit', tcIndex, tc)"
                                                    v-text="icons.mdiPencilCircleOutline"></v-icon>
                                        </v-col>
                                        <v-col class="px-2 py-0">
                                            <v-icon :color="!isDark ? 'primary' : ''"
                                                    small @click="deleteTimeCondition(tcIndex, $event)"
                                                    v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                        </v-col>
                                    </v-row>
                                </v-list-item-action>
                            </v-list-item>
                        </div>
                        <div v-else>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ $gettext('No time condition are added so far') }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                    </v-list>
                </v-menu>
                <!-- <v-divider></v-divider>
                <v-list-item class="user-cursor-pointer">
                    <v-list-item-content @click="openAddEditAppTimeCondition()">
                        <v-list-item-title>
                            <v-btn :color="!isDark ? 'primary' : ''" icon>
                                <v-icon :color="!isDark ? 'primary' : ''" small
                                        v-text="icons.mdiPlusCircleOutline"></v-icon>
                            </v-btn>
                            {{ $gettext('Add a time condition') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->
            </v-list>
        </v-menu>
        <snackbar ref="snackbar"></snackbar>
    </div>
</template>
<script>

import MixinIcon from '@/mixins/MixinIcon'
import MixinApps from '@/mixins/apps/MixinApps'
import {mapWritableState} from 'pinia'
import {usePhonesStore} from '@/stores/PhonesStore'
import {usePhoneTypesStore} from "@/stores/PhoneTypesStore";
import MixinTimeConditions from '@/mixins/time_conditions/MixinTimeConditions'
import Constants from '@/assets/js/constants'
import Snackbar from "@/components/Snackbar.vue";
import {eventBus} from "@/main";
import MixinDark from "@/mixins/database/MixinDark";

export default {
    name: 'AppIcon',
    components: {
        Snackbar
    },
    props: {
        isShow: {
            type: Boolean,
            required: false,
            default: true
        },
        packageName: {
            type: String,
            required: true,
        },
        appName: {
            type: String,
            required: true,
        },
        /**
         * appParams are required optionally, as it's required for the leftDevice but not for the app stores. This component is common between both.
         */
        appParams: {
            type: Object,
            required: false,
        },
        deviceName: {
            type: String | Boolean, // added boolean to supress an error when value received as false
            required: true,
        },
        /**
         * Details in the parent component
         * Note that this gets reset when a configuration is changed, this resolves an error, it's mentioned there.
         * */
        showMenu: {
            type: Object,
            required: true,
        },
        x: {
            type: Number,
            required: true,
        },
        y: {
            type: Number,
            required: true,
        },
        folderName: {
            type: String | Boolean, // added boolean to supress an error when value received as false
            required: false,
        },
        isAppsSourceDevice: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    mixins: [MixinIcon, MixinApps, MixinTimeConditions, MixinDark],
    data() {
        return {
            checkedImages: new Set(),

            publicPath: process.env.BASE_URL,

            mountedSuccessfully: false,
            containingFolder: '',

            weekdays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],

            showIconFromCommon: false,
            showInitials: false,
            rightClickedApp: '',

            rightClickContextMenuForApp: [
                {
                    text: 'Remove Application',
                    value: 'remove'
                },/*
                {
                    text: 'Edit Application',
                    value: 'edit'
                }*/
            ],
            appIndex: -1
        }
    },
    watch: {
        folderName: {
            /**
             *
             * @param {*} val - The value to be handled. Could be device folder name or the common folder
             *
             * For the left device:
             * First we check if the image exists in the folder, if it does, we show it, if found missing, we look into img/phone_types/unified/icons post that, the system falls back to app initials.
             *
             * For the app stores:
             *
             */
            handler(val) {

                let self = this

                self.checkIfImageExists(self.getIconPath(), (exists) => {

                    if (exists) {

                        self.showIconFromCommon = false
                        self.showInitials = false

                    } else {

                        self.checkIfImageExists(self.getIconPathFromCommon(), (exists) => {

                            if (exists) {
                                self.showIconFromCommon = true
                                self.showInitials = false
                            } else {
                                self.showIconFromCommon = false
                                self.showInitials = true
                            }

                        })

                    }

                })

            },
            deep: true
        }
    },
    mounted() {

        let self = this

        self.appIndex = self.appsGetIndex(self.currentSelectedConfigurationIndex, self.packageName)

        if (Constants.isDevelopmentEnvironment) {
            self.containingFolder = 'assets'
        } else {
            self.containingFolder = 'config'
        }

        self.mountedSuccessfully = true

    },
    methods: {

        emitDoubleClick(packageName) {
            this.$emit('installApp', packageName)
        },

        getInitials(string) {

            let names = string.split(' '),
                initials = names[0].substring(0, 1).toUpperCase()

            if (names.length > 1) {
                initials += names[names.length - 1].substring(0, 1).toUpperCase()
            } else if (string.length > 1) {
                initials += names[0].charAt(1).toUpperCase()
            }

            return initials
        },

        checkIfImageExists(url, callback) {

            // Check if we've already checked this URL
            if (this.checkedImages.has(url)) {
                callback(true);
                return;
            }

            // Otherwise it was observed that over ftp, for one of the image, it was rather showing initials when the image was present in the unified dir.
            setTimeout(() => {

                const img = new Image()
                img.src = url

                if (img.complete) {
                    this.checkedImages.add(url);
                    callback(true)
                } else {
                    img.onload = () => {
                        this.checkedImages.add(url);
                        callback(true)
                    }

                    img.onerror = () => {
                        callback(false)
                    }
                }

            }, 300)

        },

        /**
         * Retrieves the path of an icon file.
         *
         * @returns {string} The path of the icon file.
         */
        getIconPath() {

            let self = this
            // return require(`@/${self.containingFolder}/phone_types/${self.folderName}/icons/${packageName}.png`)
            // return (`@/${self.containingFolder}/phone_types/$    {self.folderName}/icons/${packageName}.png`)

            // return require(`@/${self.containingFolder}/phone_types/${self.folderName}/icons/${self.packageName}.png`)
            // return require(`./config/phone_types/${self.folderName}/icons/${self.packageName}.png`)

            // return (`/img/phone_types/${self.folderName}/icons/${self.packageName}.png`)
            return (`/img/all_icons/${self.packageName}.png`)

        },

        getIconPathFromCommon() {

            let self = this
            return (`/img/phone_types/unified/icons/${self.packageName}.png`)

        },

        deleteTimeCondition(timeConditionIndex, e) {

            let self = this
            self.timeConditionDelete(self.currentSelectedConfigurationIndex, self.appIndex, timeConditionIndex)
            this.$refs.snackbar.showSnackbar(this.$gettextInterpolate(this.$gettext('Time condition removed successfully for %{app}.'), {app: self.appName}))
            // hide menu
            self.closeContextMenu(e)

        },

        openAddEditAppTimeCondition(mode = 'add', tcIndex = -1, tc = false) {

            let self = this
            self.$emit('openAddEditAppTimeCondition', {
                packageId: self.packageName,
                deviceName: self.deviceName,
                appName: self.appName,
                mode,
                tcIndex,
                currentTimeCondition: tc
            })

            // To close the menu
            self.showMenu.value = false

        },
        setShowInitials(event) {

            let self = this
            self.showIconFromCommon = false
            self.showInitials = true

        },
        setShowIconFromCommon(event) {

            let self = this
            this.showIconFromCommon = true
            this.showInitials = false

        },
        /*processRightClickMenuForApp(item, index, event) {

            let self = this

            if (item.value === 'remove') {

                self.appDelete(self.packageName, self.deviceName)
                self.closeContextMenu(event)
                this.$refs.snackbar.showSnackbar(this.$gettextInterpolate(this.$gettext('%{app} removed successfully!'), {app: self.appName}))
                eventBus.$emit('app-deleted', self.packageName)

            } else if (item.value === 'edit') {
                self.openAddEditAppTimeCondition('edit')
            }

        }*/

        processRightClickMenuForApp(item, index, event) {

            let self = this;

            if (item.value === 'remove') {

                // Get the app before deleting it
                /*const appToRemove = self.configurations[self.currentSelectedConfigurationIndex].value.applications.find(
                    app => app.packageId === self.packageName
                );*/

                // Delete the app from applications
                self.appDelete(self.packageName, self.deviceName);
                self.closeContextMenu(event);

                // Now add the app back to installed_applications if it exists
                /*
                if (appToRemove) {
                    const availableApps = self.configurations[self.currentSelectedConfigurationIndex].value.installed_applications;

                    // Check if the app already exists in installed_applications to avoid duplicates
                    const existsInAvailable = availableApps.some(app => app.packageId === appToRemove.packageId);

                    // Check if the app is in the common apps collection
                    const isInCommonApps = self.appsCommon.applications['all applications'].some(
                        app => app.packageId === appToRemove.packageId
                    );

                    // Only add to installed_applications if it's not in common apps and not already in installed_applications
                    if (!existsInAvailable && !isInCommonApps) {
                        // Add the app to installed_applications
                        availableApps.push(appToRemove);
                    }
                }
                */

                this.$refs.snackbar.showSnackbar(this.$gettextInterpolate(this.$gettext('%{app} removed successfully!'), {app: self.appName}));
                eventBus.$emit('app-deleted', self.packageName);
            } else if (item.value === 'edit') {
                self.openAddEditAppTimeCondition('edit');
            }
        },

        show(e) {

            let self = this

            if (self.isAppsSourceDevice) {
                return
            }

            e.preventDefault()

            self.$emit('changeShowMenu', {value: false, 'packageName': self.packageName, x: e.clientX, y: e.clientY})

            this.$nextTick(() => {
                setTimeout(() => {
                    self.$emit('changeShowMenu', {
                        value: true,
                        'packageName': self.packageName,
                        x: e.clientX,
                        y: e.clientY
                    })
                }, 100)
            })

        },
        closeContextMenu(e) {

            let self = this;
            self.$emit('changeShowMenu', {value: false, 'packageName': self.packageName, x: e.clientX, y: e.clientY})

        },

    },
    computed: {
        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
        }),
        ...mapWritableState(usePhoneTypesStore, {
            appsCommon: 'appsCommon',
        }),

    }
}

</script>
<style>
.max-width-80 {
    max-width: 80px;
}

.app-icon-outline {
    border: 1px solid #e0e0e0;
}

.dragHandle {
    /* Solves the wrong drag preview on the chrome, it's a chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=525604  */
    transform: translate3d(0, 0, 0);
}

.default-text-color {
    color: rgba(0, 0, 0, 0.87);
}
</style>
